/**
 * Repayments Redux Slice
 */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { get, post } from '../../services/api/axiosInstance';
import { API_ENDPOINTS } from '../../services/api/apiEndpoints';

export const fetchRepayments = createAsyncThunk(
  'repayments/fetchAll',
  async (params, { rejectWithValue }) => {
    try {
      const response = await get(API_ENDPOINTS.REPAYMENTS.BASE, params);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message);
    }
  }
);

const repaymentSlice = createSlice({
  name: 'repayments',
  initialState: {
    repayments: [],
    isLoading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRepayments.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchRepayments.fulfilled, (state, action) => {
        state.isLoading = false;
        state.repayments = action.payload.data || action.payload;
      })
      .addCase(fetchRepayments.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError } = repaymentSlice.actions;
export default repaymentSlice.reducer;
